import { render } from "./Sidenav.vue?vue&type=template&id=0d3bb1ef"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Layout/Sidenav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d3bb1ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d3bb1ef', __exports__)) {
    console.log('reload')
    api.reload('0d3bb1ef', __exports__)
  }
  
  module.hot.accept("./Sidenav.vue?vue&type=template&id=0d3bb1ef", () => {
    console.log('re-render')
    api.rerender('0d3bb1ef', render)
  })

}


export default __exports__